"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.fromEntries = fromEntries;
exports.insertEntry = insertEntry;
exports.pick = pick;
exports.omit = omit;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a new object from the list of key-value pairs.
 * Inverse of Object.entries().
 *
 * @param {Array[]} entries Array of key-value pairs (arrays).
 * @returns {Object} New object with the keys associated with the values.
 *
 * @example
 * > fromEntries([['foo', 1], ['bar', 2]])
 * { foo: 1, bar: 2 }
 */
function fromEntries(entries) {
  // eslint-disable-next-line no-use-before-define
  return (entries || []).reduce(insertEntry, {});
}

/**
 * Insert an key-value pair into an object.
 * Primarily used with Array.reduce().
 *
 * @param {Object} obj Target object for inserting the entry.
 * @param {Array} entry Key-value pair (array) to insert.
 * @returns {Object} Original object with the new entry inserted.
 *
 * @example
 * > [['foo', 1], ['bar', 2]].reduce(insertEntry, { alpha: 0 })
 * { alpha: 0, foo: 1, bar: 2 }
 */
function insertEntry(object, _ref) {
  var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  object[key] = value;
  return object;
}

/**
 * Creates a new object from the passed object, including only the specified keys.
 * Ignores non-existent keys.
 *
 * @param {string[]} keys Keys to pick from the passed oject.
 * @param {Object} object Object to pick keys from.
 * @returns {Object} New object with the picked keys only.
 *
 * @example
 * > pick(['a', 'c'], { a: null, b: null })
 * { a: null }
 */
function pick(keys, object) {
  if (!keys || !object) {
    return {};
  }

  return keys.reduce(function (memo, key) {
    return key in object ? (memo[key] = object[key], memo) : memo;
  }, {});
}

/**
 * Creates a new object from the passed object, omitting the specified keys.
 * Ignores non-existent keys.
 *
 * @param {string[]} keys Keys to omit from the passed oject.
 * @param {Object} object Object to omit keys from.
 * @returns {Object} New object without the omitted keys.
 *
 * @example
 * > omit(['a', 'c'], { a: null, b: null })
 * { b: null }
 *
 * > omit([], { a: null, b: null })
 * { a: null, b: null }
 */
function omit(keys, object) {
  if (!object) {
    return {};
  }

  var copy = (0, _extends3.default)({}, object);
  (keys || []).forEach(function (key) {
    return delete copy[key];
  });
  return copy;
}